import { Navigate, Route, Routes } from 'react-router-dom';

import { DefaultLayout } from '@web/app/shared';

import { ChatPage } from '../pages';

export const CompareChatsRoutes = () => {
    return (
        <Routes>
            <Route element={<DefaultLayout />}>
                <Route path="/" element={<ChatPage />} />
                <Route path=":id" element={<ChatPage />} />
                <Route path="*" element={<Navigate to="/compare-chats" />} />
            </Route>
        </Routes>
    );
};
